import React from "react";
import { useNavigate } from "react-router";

import { Text, BannerAlert } from "@equidefi/ui";
import { offeringIsTerminated } from "@equidefi/shared";
import { WorkflowContainer } from "./WorkflowContainer";
import { useWorkflowContext } from "@/pages/workflow/context/WorkflowContext";

const WorkflowStepError = ({ title, text, onResume, variant = "error", buttonLabel = "Continue" }) => {
  const { offering, investment } = useWorkflowContext();
  const navigate = useNavigate();

  const isTerminated = offeringIsTerminated(offering);

  const resumeInvestment = () => {
    if (isTerminated) {
      return; // Prevent resuming terminated offerings
    }

    if (onResume) {
      onResume();
      return;
    }

    navigate(`/offerings/${offering.slug}/${investment?.id}/${investment.next.toLowerCase()}`);
  };

  return (
    <WorkflowContainer
      onContinue={isTerminated ? undefined : resumeInvestment}
      title={title}
      buttonLabel={isTerminated ? "Offering Terminated" : buttonLabel}
      disableContinue={isTerminated}>
      <BannerAlert
        status={isTerminated ? "error" : variant}
        my={4}
        description={
          <Text textStyle="body2" m={0}>
            {isTerminated
              ? "This offering has been terminated. No further actions can be taken on this investment."
              : text}
          </Text>
        }
      />
    </WorkflowContainer>
  );
};

export default WorkflowStepError;
